import DeliveryQualityInspectionDetail from '@/models/DeliveryQualityInspection/DeliveryQualityInspectionDetail';

export default class DeliveryQualityInspectionDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.deliveryQualityInspectionId  = '';
		this.deliveryQualityInspectionDeliveryQualityInspectionNo = '';
		this.deliveryInstructionDetailId  = '';
		this.deliveryInstructionDetailPart = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.qtyDeliver = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.isHideFullCheck = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			deliveryQualityInspectionId : '0',
			deliveryQualityInspectionDeliveryQualityInspectionNo : '0',
			deliveryInstructionDetailId : '0',
			deliveryInstructionDetailPart : '0',
			partId : '0',
			partPartNumber : '0',
			qtyDeliver : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}